"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputFactory = _interopRequireDefault(require("../InputFactory"));
var _toDisplayCase = _interopRequireDefault(require("../toDisplayCase"));
var _excluded = ["schema", "object", "onChange", "field", "defaultValue", "disabled"],
  _excluded2 = ["type", "label", "col"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/RelatedFactory/index.js";
function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function RelatedFactory(_ref) {
  var _this = this;
  var schema = _ref.schema,
    object = _ref.object,
    onChange = _ref.onChange,
    field = _ref.field,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState([]),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    relations = _React$useState2[0],
    setRelations = _React$useState2[1];
  // set default value
  _react["default"].useEffect(function () {
    if (defaultValue && defaultValue.length > 0) {
      setRelations(defaultValue);
    } else {
      setRelations([{
        id: randomString()
      }]);
    }
  }, [defaultValue]);
  function onClickAdd() {
    setRelations([].concat((0, _toConsumableArray2["default"])(relations), [{
      id: randomString()
    }]));
  }
  var onClickRemove = function onClickRemove(index) {
    var objects = (0, _toConsumableArray2["default"])(relations);
    objects.splice(index, 1);
    setRelations(objects);
    onChange(objects);
  };
  function onChangeValue(index, value, field) {
    relations[index][field] = value;
    onChange(relations);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("hr", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 13
    }
  }), relations.map(function (relation, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: relation.index,
      className: "row g-3",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 25
      }
    }, Object.keys(schema.fields).map(function (key) {
      var _schema$fields$key = schema.fields[key],
        type = _schema$fields$key.type,
        label = _schema$fields$key.label,
        col = _schema$fields$key.col,
        options = (0, _objectWithoutProperties2["default"])(_schema$fields$key, _excluded2);
      if (options.hasOwnProperty('write') && !options.write) return null;
      var isRelatedType = options._type === 'Related';
      var inputProps = (0, _objectSpread2["default"])({
        object: isRelatedType ? object : relation,
        field: key,
        onChange: onChangeValue.bind(_this, index),
        type: type,
        className: 'fs-sm',
        disabled: disabled
      }, options);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: isRelatedType ? '' : col || "col-md-4",
        key: key,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70,
          columnNumber: 41
        }
      }, !isRelatedType && /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label fs-sm mt-2",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 49
        }
      }, label || (0, _toDisplayCase["default"])(key)), props.componentFactory ? /*#__PURE__*/_react["default"].createElement(props.componentFactory, inputProps) : /*#__PURE__*/_react["default"].createElement(_InputFactory["default"], Object.assign({}, inputProps, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 53
        }
      })));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pb-1 col mt-auto",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 29
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      disabled: disabled,
      onClick: onClickRemove.bind(_this, index),
      type: "button",
      className: "btn btn-link text-danger btn-sm fs-xs",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 33
      }
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "bi bi-trash",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 37
      }
    }))));
  }), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: disabled,
    onClick: onClickAdd,
    type: "button",
    className: "btn btn-light btn-sm fs-xs mt-3 text-uppercase",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-plus me-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 17
    }
  }), "ADD MORE ", (0, _toDisplayCase["default"])(field)));
}
var _default = exports["default"] = RelatedFactory;